import Marquee from "react-fast-marquee";
import { marqueeItems } from "@/data/portfolio";

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-t border-white/10 py-8 md:py-10">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {marqueeItems.map((item, i) => (
        <span key={item} className="flex items-center">
          <span className="font-display text-3xl font-black uppercase tracking-tight text-white/90 md:text-5xl">
            {item}
          </span>
          <span className="mx-8 font-mono text-cyan-400 md:mx-12">[{String(i + 1).padStart(2, "0")}]</span>
        </span>
      ))}
    </Marquee>
  </div>
);
